import { Component } from 'react';
import ReactSelect from '../../components/ReactSelect';

class Actions extends Component {
    constructor(props) {
        super();

        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
        this.handleChange = this.handleChange.bind(this);

        this.prompt = `You are a world-class SEO and Editorial Analyst with deep expertise in Google Discover's ranking algorithm and user behavior. I have a published article at the following URL: ${props.url} . Primary Goal: Increase the Click-Through Rate (CTR) of this article on Google Discover. Constraint: The optimizations must not negatively impact the article's existing SEO rankings for its primary keywords. Task: 1. Fetch the Article: Fetch the full content, schema markup (especially Article or NewsArticle), and Open Graph data (og:title, og:image) of the provided URL; 2. Identify the article's core topic, primary SEO keywords, and the main entity or subject. Output: 1. Google Discover Headline (og:title) Optimization: Based on your analysis, generate 5 alternative headlines specifically engineered to be compelling for a Google Discover audience. For each headline, provide a brief (1-2 sentence) rationale explaining why it works, referencing principles of curiosity, emotional resonance, or specificity; 2. Image Analysis and Recommendations: Analyze the primary image of the article (the og:image or main article image) and provide and Provide actionable recommendations to improve this image's performance in Discover. Consider factors like: Visual Appeal: Is it high-quality, vibrant, and engaging? Aspect Ratio: Is it close to the ideal 16:9? Composition: Is the subject clear and not obscured by text or logos?; 3. Contingency Plan: If you are unable to fetch the content of the URL, clearly state this. Then, perform the headline and image analysis based only on the information available in the URL's slug and any available metadata you can infer. Don't include any explainers or additional info beyond the requested output.`;

        this.state = {
            isOpen: false,
        };

        this.options = [
            {
                label: (
                    <div className="live-report-ais">
                        <img src="/static/img/grok.png" />
                        Grok
                    </div>
                ),
                value: 'grok',
                link: `https://x.com/i/grok?text=${this.prompt}`,
            },
            {
                label: (
                    <div className="live-report-ais">
                        <img src="/static/img/perplexity-ai-icon-black-logo-png_seeklogo-611679.png" />
                        Perplexity
                    </div>
                ),
                value: 'Perplexity',
                link: `https://www.perplexity.ai/search/new?q=${this.prompt}`,
            },
            {
                label: (
                    <div className="live-report-ais">
                        <img src="/static/img/google-ai-1.svg" />
                        Google AI Mode
                    </div>
                ),
                value: 'Google AI Mode',
                link: `https://www.google.com/search?udm=50&aep=11&q=${this.prompt}`,
            },
            {
                label: (
                    <div className="live-report-ais">
                        <img src="/static/img/chatgpt-icon.webp" />
                        ChatGPT
                    </div>
                ),
                value: 'ChatGPT',
                link: `https://chat.openai.com/?q=${this.prompt}`,
            },
            {
                label: (
                    <div className="live-report-ais">
                        <img src="/static/img/claude-ai-icon.webp" />
                        Claude.ai
                    </div>
                ),
                value: 'Claude.ai',
                link: `https://claude.ai/new?q=${this.prompt}`,
            },
        ];
    }

    onOpen() {
        this.setState({
            isOpen: true,
        });
    }

    onClose() {
        this.setState({
            isOpen: false,
        });
    }

    handleChange(value) {
        const selectedOne = this.options.find((item) => item.value === value);
        const a = document.createElement('a');

        a.href = selectedOne.link;
        a.target = '_blank';
        a.click();
    }

    render() {
        return (
            <ReactSelect
                options={this.options}
                value={'Optimize Headline'}
                isSearchable={false}
                placeholder="Optimize Headline"
                onChange={(value) => this.handleChange(value)}
                blurInputOnSelect={true}
                classname="mr-10"
                controlStyles={{
                    width: 'fit-content',
                    minWidth: 0,
                }}
                placeholderStyles={{
                    color: 'black',
                }}
                components={{
                    DropdownIndicator: () => null, // removes the arrow
                    IndicatorSeparator: () => null, // removes the vertical line
                }}
            />
        );
    }
}

export default Actions;
